// frontend/src/components/Manual/sections/SectionIntro.tsx

import React from 'react';
import { DiagramBox } from '../diagrams/DiagramBox';

export const SectionIntro: React.FC = () => {
  return (
    <div className="manual-section">
      <h2>📌 Primeiros Passos</h2>
      <p className="section-purpose">
        Bem-vindo(a) à plataforma. Este manual mostra, passo a passo, como usar
        cada tela.
      </p>

      <h3>O que é esta plataforma</h3>
      <p>
        A plataforma transforma dados brutos em decisões automatizadas. Você
        importa um dataset, o sistema prepara os dados, treina modelos e
        disponibiliza predições — tudo pela interface, sem escrever código.
      </p>

      <h3>Jornada do usuário</h3>
      <p>
        O fluxo completo, do dado bruto à decisão, segue esta ordem:
      </p>

      <DiagramBox
        title="Jornada do usuário"
        steps={[
          { icon: '📤', label: 'Importar seus dados' },
          { icon: '🔧', label: 'Processar (ORC)' },
          { icon: '🔬', label: 'Analisar (EDA)' },
          { icon: '🧹', label: 'Preparar features' },
          { icon: '🤖', label: 'Treinar modelos' },
          { icon: '🎯', label: 'Fazer predições' },
        ]}
      />

      <h3>Como navegar</h3>
      <p>
        O menu lateral esquerdo desta página lista todas as telas do manual.
        Clique em qualquer item para ver as instruções daquela tela.
      </p>

      <h3>Estrutura da plataforma</h3>
      <p>
        O menu principal do sistema está organizado em 4 seções:
      </p>

      <ul>
        <li>
          <strong>Raiz</strong> — Visão Geral, Operações e Estratégias
        </li>
        <li>
          <strong>Dados</strong> — Importar Dados, Processamento, Meus Dados,
          Acompanhamento e Jornada dos Dados
        </li>
        <li>
          <strong>Inteligência</strong> — Análise, Exploração, Preparação,
          Modelos, Comparar Modelos e Predições
        </li>
        <li>
          <strong>Conta</strong> — Meu Perfil e Ajustes
        </li>
      </ul>

      <h3>O que você pode fazer aqui</h3>
      <ul>
        <li>
          <strong>Importar</strong> — subir seu próprio dataset em CSV
        </li>
        <li>
          <strong>Processar</strong> — rodar o pipeline científico que
          transforma dados brutos
        </li>
        <li>
          <strong>Explorar</strong> — entender a distribuição, os alvos e a
          qualidade dos dados
        </li>
        <li>
          <strong>Treinar</strong> — gerar modelos automaticamente com múltiplos
          algoritmos
        </li>
        <li>
          <strong>Comparar</strong> — ver qual versão/estratégia performa melhor
        </li>
        <li>
          <strong>Predizer</strong> — usar um modelo em produção para gerar
          decisões em tempo real
        </li>
      </ul>

      <div className="manual-tip">
        <p>
          💡 <strong>Dica:</strong> Se for a primeira vez que você usa a
          plataforma, comece por <strong>Importar Dados</strong>. Todo o resto
          do fluxo depende de ter um dataset carregado.
        </p>
      </div>

      <h3>Precisa de ajuda?</h3>
      <p>
        Use o menu lateral desta página para consultar a tela específica que
        você quer entender. Cada seção mostra o passo a passo, o que esperar
        como resultado e dicas de uso.
      </p>
    </div>
  );
};